module.exports = __webpack_public_path__ + "static/media/SarahSwitek_08_EnergyLevel-Confirmation_2.70b58a32.mp3";